import styled from "styled-components";

export const Container = styled.tr`
  td {
    text-align: center;
    padding: 40px 20px;
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
